<template>
<div class="chapter">
<div class="inner_page">
<div id="_idContainer000">
<p class="ORIM-Book-Title--Front-Matter-">The Return of Mr Campion</p>
<p class="ORIM-Book-Subtitle--Front-Matter-">An Albert Campion Mystery</p>
<p class="ORIM-Author-Name--Front-Matter-">Margery Allingham</p>
<p class="ORIM-Author-Name--Front-Matter-"><img alt="Logo" src="images/logo2.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// vol001.vue?0d41b20a